module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_7.08dd76ac.jpg";